import _ from "lodash";
import moment from "moment";

const Utils = {
  dateTime: (dt) => moment(dt).format("DD-MM-YYYY HH:mm"),

  apiUrl: (path) => process.env.REACT_APP_API_URL + "/" + path,

  apiHeaders: (extraparams = null) => {
    let headers = {
      headers: {
        "x-api-key": "$2a$08$y519PHKU/tBCS9fSk.lRfeKRmw.8z0UyRv3ujLOyZ7JSY0AZpCWTa",
        "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "PUT,GET,POST,DELETE,OPTIONS,PATCH",
        "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token, token, access-control-allow-origin",
        Accept: "application/json, text/plain, */*",
      },
    };

    const uData = Utils.getUserData();
    if (uData && _.get(uData, "token", false)) {
      headers["headers"]["token"] = uData.token;
    }

    if (extraparams) {
      headers = { ...headers, ...extraparams };
    }
    return headers;
  },

  isLoggedIn: () => {
    const dt = Utils.getUserData();
    return dt!==false && _.get(dt, "token", false) !== false;
  },

  isHR: () => {
    const dt = Utils.getUserData();
    return dt!==false && _.get(dt, "isHR", false) === true;
  },

  isPhotographer: () => {
    const dt = Utils.getUserData();
    return dt!==false && _.get(dt, "isPG", false) === true;
  },

  hasBrand: () => {
    const dt = Utils.getUserData();
    return dt!==false && _.get(dt, "hotel_id", false) !== false && _.get(dt, "hotel_id", false) !== null;
  },

  removeSession: () => {
    let dt = Utils.getUserData();
    // console.log(dt, "session data")
    dt.token = false;
    // const backup = localStorage.getItem(process.env.REACT_APP_APPNAME + '-userData');
    localStorage.setItem(process.env.REACT_APP_APPNAME + "-userData", JSON.stringify(dt));
  },

  getUserData: () => {
    let userData = localStorage.getItem(process.env.REACT_APP_APPNAME + "-userData");
    if (userData) {
      return JSON.parse(userData);
    } else {
      return false;
    }
  },

  setUserData: (data) => {
    const uData = _.get(data, "userData", false);
    // return;
    if (uData === false) {
      //=== logout
      localStorage.removeItem(process.env.REACT_APP_APPNAME + "-userData");
    } else {
      let userData = Utils.getUserData();
      if (!userData) {
        userData = {};
      }
      uData["token"] = _.get(data, "token", false);
      uData[`stepData${userData.id}`] = userData[`stepData${userData.id}`];
      userData = { ...userData, ...uData };
      localStorage.setItem(process.env.REACT_APP_APPNAME + "-userData", JSON.stringify(userData));
    }
  },

  saveUserData: (data, stepData) => {
    if (_.get(data, "token", false)) {
      data[`stepData${data.id}`] = stepData;
      localStorage.setItem(process.env.REACT_APP_APPNAME + "-userData", JSON.stringify(data));
    }
  },

  addToUserData: (data) => {
    let userData = Utils.getUserData();
    if (!userData) {
      userData = {};
    }
    userData = { ...userData, ...data };
    localStorage.setItem(process.env.REACT_APP_APPNAME + "-userData", JSON.stringify(userData));
  },

  canAccess: (module) => {
    const udata = Utils.getUserData();
    if (udata.role_id === parseInt(process.env.REACT_APP_SUPERADMIN_ROLE)) {
      return true;
    }
    return _.get(udata, "rbac", []).includes(module);
  },

  showPagination: (pageInfo, gotoPage) => {
    const curpage = Math.ceil(pageInfo.start / pageInfo.limit) + 1;
    const totpage = Math.ceil(pageInfo.total / pageInfo.limit);

    return (
      <div className="flex justify-between items-center mt-4">
        <span className="text-sm text-gray-600">
          Showing {pageInfo.start + 1} to {_.min([pageInfo.start + pageInfo.limit, pageInfo.total])} of {pageInfo?.total || 0} Records
        </span>

        <div className="flex space-x-2">
          {curpage > 1 && (
            <button disabled={curpage === 1} onClick={gotoPage(curpage - 1)} className="px-3 py-1 border rounded disabled:opacity-50">
              Prev
            </button>
          )}

          {new Array(totpage).fill(0).map((v, p) => (
            <button key={p} onClick={gotoPage(p + 1)} className={`px-3 py-1 border rounded ${curpage === p + 1 ? "bg-blue-600 text-white" : ""}`}>
              {p + 1}
            </button>
          ))}
          <button disabled={curpage === totpage} onClick={gotoPage(curpage + 1)} className="px-3 py-1 border rounded disabled:opacity-50">
            Next
          </button>
        </div>
      </div>
    );
  },
};

export default Utils;
